import React, {Component} from "react";
import Particles from "react-particles-js";
import './BackgroundParticles.scss';

export default function BackgroundParticles() {
    const width = window.innerWidth || document.documentElement.clientWidth ||
        document.body.clientWidth;
    const height = window.innerHeight || document.documentElement.clientHeight ||
        document.body.clientHeight;

    const numOfParticles = Math.round(0.00008503401360544217 * height * width);

    return <Particles className="background-particles"
                      params={{
                          "particles": {
                              "number": {
                                  "value": numOfParticles
                              },
                              "color": {
                                  "value": "#feb62f"
                              },
                              "shape": {
                                  "type": "circle",
                                  "stroke": {
                                      "width": 0,
                                      "color": "#000000"
                                  },
                                  "polygon": {
                                      "nb_sides": 5
                                  },
                                  "image": {
                                      "src": "img/github.svg",
                                      "width": 100,
                                      "height": 100
                                  }
                              },
                              "opacity": {
                                  "value": 0.5,
                                  "random": true,
                                  "anim": {
                                      "enable": false,
                                      "speed": 1,
                                      "opacity_min": 0.3,
                                      "sync": false
                                  }
                              },
                              "size": {
                                  "value": 6,
                                  "random": true,
                                  "anim": {
                                      "enable": false,
                                      "speed": 40,
                                      "size_min": 5,
                                      "sync": false
                                  }
                              },
                              "line_linked": {
                                  "enable": true,
                                  "distance": 150,
                                  "color": "#838383",
                                  "opacity": 0.7,
                                  "width": 1
                              },
                              "move": {
                                  "enable": true,
                                  "speed": 3,
                                  "direction": "none",
                                  "random": false,
                                  "straight": false,
                                  "out_mode": "out",
                                  "bounce": true,
                                  "attract": {
                                      "enable": false,
                                      "rotateX": 600,
                                      "rotateY": 1200
                                  }
                              }
                          },
                          "interactivity": {
                              "events": {
                                  "onhover": {
                                      "enable": true,
                                      "mode": "repulse"
                                  }
                              }
                          }
                      }}/>;
}